import { render, staticRenderFns } from "./detailTable16.vue?vue&type=template&id=7f9bb3a3&scoped=true"
import script from "./detailTable16.vue?vue&type=script&lang=js"
export * from "./detailTable16.vue?vue&type=script&lang=js"
import style0 from "./detailTable16.vue?vue&type=style&index=0&id=7f9bb3a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9bb3a3",
  null
  
)

export default component.exports